// icons/types.ts
export type IconToken =
  | 'magnet'
  | 'accessibility'
  | 'info'
  | 'error'
  | 'check'
  | 'checkcircle2'
  | 'clock'
  | 'playcircle'
  | 'checkcheck'
  | 'xcircle'
  | 'whatsapp'
  | 'default'
  | 'rotateccw'
  | 'waves'
  | 'snowflake'
  | 'flame'
  | 'boxes';

export type IconSize = 'xs' | 'sm' | 'md' | 'lg' | number;

export type IconProps = {
  name: IconToken | string; // viene del backend como string
  size?: IconSize;
  title?: string;
  className?: string;
  'aria-hidden'?: boolean;
  style?: React.CSSProperties;
  color?: string;
};

export function normalizeToken(raw: string): IconToken {
  const t = (raw ?? '').trim().toLowerCase();
  const allowed: IconToken[] = [
    'magnet',
    'accessibility',
    'info',
    'error',
    'check',
    'whatsapp',
    'default',
    'rotateccw',
    'waves',
    'snowflake',
    'checkcircle2',
    'clock',
    'playcircle',
    'checkcheck',
    'xcircle',
    'flame',
    'boxes',
  ];

  return (allowed.includes(t as IconToken) ? (t as IconToken) : 'default');
}

export const sizeToPx = (size: IconSize = 'md') => {
  const map = { xs: 12, sm: 16, md: 20, lg: 24 };
  return typeof size === 'number' ? size : map[size] ?? map.md;
};
